/*
 * @Author: Teemo Ding
 * @Date: 2021-10-27 14:50:56
 * @LastEditTime: 2021-10-27 17:08:28
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/Components/ShippingRate/config.tsx
 */
import { EnumMode } from '@/src/components/Antd/NumberInput/NumberInput';
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import { Form } from 'antd';
import React from 'react';
import { TableNumberInput } from 'src/components/EditableTable/TableForm/TableForm';
import css from './css.module.less';

export const deliveryPricesColumns = (name, { getI18n }) => [
  {
    title: getI18n('general.currency'),
    dataIndex: 'currency',
    default: true,
    key: 'currency',
    minWidth: 480,
    childGenerate: (text, record, index) => text,
  },
  {
    title: (
      <div>
        <EditIcon />
        <span>{getI18n('storeLogistics.components.deliveryPrice')}</span>
      </div>
    ),
    dataIndex: 'price',
    default: true,
    key: 'price',
    minWidth: 480,
    childGenerate: (text, record, index) => (
      <Form.Item className={css.tableNumberInput} name={[name, index, 'price']}>
        <TableNumberInput
          mode={EnumMode.money}
          // error={priceError}
          rightPosition
          value={text}
          // max={record.maxAmount}
          valueSuffix={` ${record.currency}`}
          suffix={record.currency}
        />
      </Form.Item>
    ),
  },
  {
    title: '',
    dataIndex: 'none',
    default: true,
    key: 'none',
    minWidth: 128,
  },
];

export const additionalDeliveryPriceColumns = ({ getI18n }) => [
  {
    title: getI18n('general.currency'),
    dataIndex: 'currency',
    default: true,
    key: 'currency',
    minWidth: 480,
    childGenerate: (text, record, index) => text,
  },
  {
    title: (
      <div>
        <EditIcon />
        <span>{getI18n('storeLogistics.components.deliveryPrice')}</span>
      </div>
    ),
    dataIndex: 'price',
    default: true,
    key: 'price',
    minWidth: 480,
    childGenerate: (text, record, index) => (
      <Form.Item
        className={css.tableNumberInput}
        name={['additionalDeliveryPrices', index, 'price']}>
        <TableNumberInput
          mode={EnumMode.money}
          // error={priceError}
          rightPosition
          value={text}
          // max={record.maxAmount}
          valueSuffix={` ${record.currency} / ${getI18n(
            'storeLogistics.components.perunit',
          )}`}
          suffix={`${record.currency} / ${getI18n(
            'storeLogistics.components.perunit',
          )}`}
        />
      </Form.Item>
    ),
  },
  {
    title: '',
    dataIndex: 'none',
    default: true,
    key: 'none',
    minWidth: 128,
  },
];

export const fixAmountColumns = ({ getI18n }) => [
  {
    title: getI18n('general.currency'),
    dataIndex: 'currency',
    default: true,
    key: 'currency',
    minWidth: 480,
    childGenerate: (text, record, index) => text,
  },
  {
    title: (
      <div>
        <EditIcon />
        <span>
          {getI18n('storeLogistics.warehouseLocations.additionalFee')}
        </span>
      </div>
    ),
    dataIndex: 'price',
    default: true,
    key: 'price',
    minWidth: 480,
    childGenerate: (text, record, index) => (
      <Form.Item
        className={css.tableNumberInput}
        name={['FixAmountDeliveryPrices', index, 'price']}>
        <TableNumberInput
          mode={EnumMode.money}
          // error={priceError}
          rightPosition
          value={text}
          // max={record.maxAmount}
          valueSuffix={` ${record.currency}`}
          suffix={`${record.currency}`}
        />
      </Form.Item>
    ),
  },
  {
    title: '',
    dataIndex: 'none',
    default: true,
    key: 'none',
    minWidth: 128,
  },
];
